module.exports = __webpack_public_path__ + "img/simon_zsuzsi_c80_A3-04.5655c4e4.jpg";